export default __webpack_public_path__ + "static/media/CruiseQueenImgOne.c8971a45.png";